import { render, staticRenderFns } from "./MajorChoose.vue?vue&type=template&id=a0765842&scoped=true"
import script from "./MajorChoose.vue?vue&type=script&lang=js"
export * from "./MajorChoose.vue?vue&type=script&lang=js"
import style0 from "./MajorChoose.vue?vue&type=style&index=0&id=a0765842&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0765842",
  null
  
)

export default component.exports